import { render } from "./dvcMerchantAloneSet.vue?vue&type=template&id=984dc7f2&scoped=true"
import script from "./dvcMerchantAloneSet.vue?vue&type=script&lang=js"
export * from "./dvcMerchantAloneSet.vue?vue&type=script&lang=js"

import "./dvcMerchantAloneSet.vue?vue&type=style&index=0&id=984dc7f2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-984dc7f2"]])

export default __exports__